// import { get } from 'lodash';
// import request from '@/utils/requestPoint';
import request from '@/utils/request';

// // 查询勋章墙
// export function getUserBadgeInfo(params) {
//   return request('/promotion-rest-boot/promotion/badge/get-user-badge-infor', {
//     method: 'POST',
//     data: params,
//   });
// }

// // 中奖详情
// export function qryUserRewardDetail(params) {
//   return request('/promotion-rest-boot/promotion/reward/qry-user-reward-detail', {
//     method: 'POST',
//     data: params,
//   });
// }

// page builder查询
export function qryCmsPageDetail(params) {
  return request('/appops/cms/client/page/detail', {
    method: 'POST',
    data: params,
  });
}

export function qryUserMMSInfo(params) {
  return request('/promotion-rest-boot/promotion/membership/qry-user-mms-info', {
    method: 'POST',
    data: params,
  });
}

export function qryUserMMSInfoDXP(params) {
  return request('/promotion-rest-boot/dxp/loyalty/v1/memberships/info', {
    method: 'GET',
    params,
  });
}

export function qryMMSTypeInfo(params) {
  return request('/promotion-rest-boot/promotion/membership/mms-Type-info', {
    method: 'POST',
    data: params,
  });
}

export function qryMMSTypeInfoDXP(membershipTypeCode) {
  return request(
    `/promotion-rest-boot/dxp/loyalty/v1/memberships/membershipType/${membershipTypeCode}`,
    {
      method: 'GET',
    },
  );
}

export function qryUpgradeMethod(params) {
  return request('/promotion-rest-boot/promotion/membership/qry-upgrade-method', {
    method: 'POST',
    data: params,
  });
}

export function qryUpgradeMethodDXP(params) {
  return request('/promotion-rest-boot/dxp/loyalty/v1/memberships/upgrade-methods', {
    method: 'GET',
    params,
  });
}
export function qryUpgradeGuidUrl(params) {
  return request('/promotion-rest-boot/dxp/loyalty/v1/memberships/upgradeGuidUrl', {
    method: 'GET',
    params,
  });
}
export function qryUserRewardList(params) {
  return request('/promotion-rest-boot/promotion/membership/qry-user-reward-list', {
    method: 'POST',
    data: params,
  });
}

export function qryUserRewardListDXP(params) {
  return request('/promotion-rest-boot/dxp/loyalty/v1/memberships/reward-instance/history', {
    method: 'GET',
    params,
  });
}

export function qryUserRewardDetail(params) {
  return request('/promotion-rest-boot/promotion/membership/qry-user-reward-detail', {
    method: 'POST',
    data: params,
  });
}

export function qryUserRewardDetailDXP(params) {
  return request(
    `/promotion-rest-boot/dxp/loyalty/v1/memberships/reward-instance/${params.keyId}`,
    {
      method: 'GET',
    },
  );
}

export function claminMemReward(params) {
  return request('/promotion-rest-boot/promotion/membership/claim-reward', {
    method: 'POST',
    data: params,
  });
}

export function claminMemRewardDXP(params) {
  return request('/promotion-rest-boot/dxp/loyalty/v1/memberships/reward-instance/claim', {
    method: 'POST',
    data: params,
  });
}

// 查询奖品历史列表（通用接口，所有渠道）
export function getRewardHistory(params) {
  return request('/dxp/loyalty/v1/reward-instance/history', {
    method: 'GET',
    params,
  });
}

// 查询奖品实例详情
export function getRewardDetail(rewardInstanceId) {
  return request(`/dxp/loyalty/v1/reward-instance/${rewardInstanceId}`, {
    method: 'GET',
  });
}

// 查询奖品权益配置详情（锁定状态）
export function getBenefitRewardDetail(benefitRewardId) {
  return request(`/dxp/loyalty/v1/memberships/reward/${benefitRewardId}`, {
    method: 'GET',
  });
}

// 领取奖品
export function claimReward(data) {
  return request('/dxp/loyalty/v1/reward-instance/claim', {
    method: 'POST',
    data,
  });
}

// 查询PIN码格式
export function getPinFormat() {
  return request('/dxp/loyalty/v1/coupon/pin/format', {
    method: 'GET',
  });
}

// 使用奖品
export function useReward(data) {
  return request('/dxp/loyalty/v1/reward-instance/use', {
    method: 'POST',
    data,
  });
}
